<script>
    export default {}
</script>

<template>
    <filter>
        <feColorMatrix
                type="matrix"
                values="1 0 0 0 0 0 2 0 0 0 0 0 0 .5 0 0 0 0 1 0"/>
    </filter>
</template>
